import { IModel, Model, ModelRecord } from './Model';

export interface IVaccineManufacturerModel extends IModel {
  vaccineManufacturerId: number;
  name: string;
}

export class VaccineManufacturerModel
  extends Model
  implements ModelRecord<IVaccineManufacturerModel>
{
  vaccineManufacturerId: number;
  name: string;

  constructor(params?: Partial<IVaccineManufacturerModel>) {
    super(params);
    this.vaccineManufacturerId = _.defaultTo(params?.vaccineManufacturerId, 0);
    this.name = _.defaultTo(params?.name, '');
  }
}
